import { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { GraduationCap, Info } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { ESSAP_CATS } from "@/lib/essap";

const tabs = [{ key: "", label: "Présentation", icon: Info }, ...ESSAP_CATS];

export default function EssapShell() {
  const [logo, setLogo] = useState(null);
  useEffect(() => { api.get("/essap").then((r) => setLogo(r.data.logo)).catch(() => {}); }, []);
  return (
    <div>
      <section className="relative overflow-hidden bg-emerald-900 guilloche grain">
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16 flex flex-col sm:flex-row items-start sm:items-center gap-8">
          <div className="h-24 w-24 sm:h-28 sm:w-28 shrink-0 rounded-2xl bg-white grid place-items-center overflow-hidden shadow-xl">
            {logo ? <img src={fileUrl(logo)} alt="Logo ESSAP" data-testid="essap-logo" className="h-full w-full object-contain p-2" /> : <GraduationCap data-testid="essap-logo-placeholder" className="h-12 w-12 text-emerald-700" />}
          </div>
          <div className="space-y-3 min-w-0">
            <div className="text-xs uppercase tracking-[0.16em] text-emerald-200 font-semibold">École de formation des AP</div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white">ESSAP</h1>
            <p className="text-emerald-100/90 text-base md:text-lg max-w-2xl">École supérieure des sciences de santé et d'assistance en pharmacie</p>
          </div>
        </div>
      </section>
      <div className="sticky top-16 z-30 bg-white/90 backdrop-blur-xl border-b border-emerald-900/10">
        <nav data-testid="essap-subnav" className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex gap-1 overflow-x-auto py-2">
          {tabs.map((t) => (
            <NavLink key={t.key} to={t.key ? `/essap/${t.key}` : "/essap"} end data-testid={`essap-tab-${t.key || "presentation"}`}
              className={({ isActive }) => `inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${isActive ? "bg-emerald-700 text-white font-semibold" : "text-slate-600 hover:bg-emerald-50 hover:text-emerald-800"}`}>
              <t.icon className="h-4 w-4" /> {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
